import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

function setAccountHierarchy(accountsGroupByCountry) {
  var accountsGroupByCountryModified = accountsGroupByCountry;
  var childrenAccountsWithFather = [];
  accountsGroupByCountryModified.forEach(function (element) {
    var fatherAccounts = element.accounts.filter(function (elementAccount) {
      return !elementAccount.fatherAccount;
    });
    var childrenAccounts = element.accounts.filter(function (elementAccount) {
      return elementAccount.fatherAccount;
    });
    fatherAccounts.forEach(function (fatherAccount) {
      var hisChildrenAccounts = childrenAccounts.filter(function (childrenAccount) {
        return childrenAccount.fatherAccount === fatherAccount.entityId;
      });
      fatherAccount.childrenAccounts = hisChildrenAccounts;
      childrenAccountsWithFather = [].concat(_toConsumableArray(childrenAccountsWithFather), _toConsumableArray(hisChildrenAccounts));
    });
    var childrenAccountsWithoutFather = childrenAccounts.filter(function (childrenAccount) {
      return !childrenAccountsWithFather.includes(childrenAccount);
    });
    fatherAccounts = [].concat(_toConsumableArray(fatherAccounts), _toConsumableArray(childrenAccountsWithoutFather));
    element.accounts = fatherAccounts;
  });
  return accountsGroupByCountryModified;
}

export { setAccountHierarchy as default };
